<style lang="scss">
.faq-drawer {
  &__trigger {
    position: absolute;
    top: 20px;
    right: 20px;
    animation: jittery 4s infinite;
  }

  &__avatar {
    margin-left: -16px;
  }

  &__link {
    text-decoration: none;
  }

  &__list {
    list-style-type: none;
  }

  &__item {
    position: relative;

    &::before {
      position: absolute;
      top: calc(50% - 2px);
      left: -8px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #999;
      content: '';
    }
  }

  // [override] Vuetify - VCheckbox
  .v-input--checkbox.v-input--is-label-active .v-label {
    text-decoration: line-through;
  }
}

.--jittery-once {
  animation: jittery 1s 1;
}

@keyframes jittery {
  5%,
  50% {
    transform: scale(1);
  }
  10% {
    transform: scale(0.9);
  }
  15% {
    transform: scale(1.15);
  }
  20% {
    transform: scale(1.15) rotate(-5deg);
  }
  25% {
    transform: scale(1.15) rotate(5deg);
  }
  30% {
    transform: scale(1.15) rotate(-3deg);
  }
  35% {
    transform: scale(1.15) rotate(2deg);
  }
  40% {
    transform: scale(1.15) rotate(0);
  }
}
</style>

<template>
  <div class="faq-drawer">
    <v-btn
      absolute
      flat
      icon
      color="orange"
      text
      class="faq-drawer__trigger"
      @click="toggle"
    >
      <v-icon large>help_outline</v-icon>
    </v-btn>
    <v-navigation-drawer v-model="self" fixed right temporary width="400">
      <slot>
        <v-list>
          <v-list-tile>
            <v-list-tile-avatar>
              <v-icon large color="orange" class="faq-drawer__avatar">
                help_outline
              </v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title class="title">{{ title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile v-for="item in items" :key="item.id" class="mb-4">
            <v-list-tile-action>
              <v-checkbox hide-details class="mt-0">
                <div slot="label">
                  <p v-if="item.text" class="mb-0">
                    {{ item.text }}
                    <template v-if="item.icons">
                      <v-icon v-for="icon in item.icons" :key="icon">
                        {{ icon }}
                      </v-icon>
                    </template>
                    <v-icon
                      v-if="item.href"
                      small
                      color="primary"
                      :class="{ '--jittery-once': feedback }"
                      @click.stop="copy(item.href)"
                    >
                      assignment
                    </v-icon>
                  </p>
                  <div v-if="item.list">
                    <p class="mb-0">{{ item.list.title }}</p>
                    <ul class="faq-drawer__list pl-2">
                      <li
                        v-for="(text, index) in item.list.items"
                        :key="index"
                        class="faq-drawer__item"
                      >
                        {{ text }}
                      </li>
                    </ul>
                  </div>
                </div>
              </v-checkbox>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </slot>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'FaqSwitchDrawer',
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      self: false,
      feedback: false,
    }
  },
  methods: {
    toggle() {
      this.self = !this.self
    },
    copy(text) {
      this.feedback = true
      // Put the text to copy into a <span>
      const span = document.createElement('span')
      span.textContent = text

      // Preserve consecutive spaces and newlines
      span.style.whiteSpace = 'pre'
      span.style.userSelect = 'all'

      // Add the <span> to the page
      document.body.appendChild(span)

      // Make a selection object representing the range of text selected by the user
      const selection = window.getSelection()
      const range = window.document.createRange()
      selection.removeAllRanges()
      range.selectNode(span)
      selection.addRange(range)

      // Copy text to the clipboard
      try {
        window.document.execCommand('copy')
        return Promise.resolve()
      } catch (e) {
        return Promise.reject(e)
      } finally {
        // Cleanup
        selection.removeAllRanges()
        window.document.body.removeChild(span)
        setTimeout(() => {
          this.feedback = false
        }, 1000)
      }
    },
  },
}
</script>
